import { Typography } from "@material-tailwind/react";
import React, { useState, ChangeEvent, useEffect } from "react";
import ImageUpload from "../../components/booking/ImageUpload";
import NextBack from "../../components/booking/NextBack";

import { useMutation } from "react-query";
import api from "../../services/apiService";
import ApiRoutes from "../../services/apiRoutes";
import { toast } from "react-toastify";
import { useSelectedBoatStore } from "../../store/boat/boatDetails";
import { useNavigate } from "react-router-dom";
import { routerPaths } from "../../services/path";
import { handleErrorMessage } from "../../utility";

interface ImagePreview {
  file: File | null;
  preview: string | undefined;
}

const EditPhotos: React.FC = () => {
  const { selectedBoat } = useSelectedBoatStore();
  const navigate = useNavigate();
  const [imagePreviews, setImagePreviews] = useState<
    Record<string, ImagePreview>
  >({
    FrontImage: { file: null, preview: selectedBoat?.frontImageUrl },
    BackImage: { file: null, preview: selectedBoat?.backImageUrl },
    InteriorImage: { file: null, preview: selectedBoat?.interiorImageUrl },
    ExteriorImage: { file: null, preview: selectedBoat?.exteriorImageUrl },
    SeaViewImage: { file: null, preview: selectedBoat?.seaViewImageUrl },
  });

  const onSubmit = async () => {
    const formData = new FormData();
    const boatId = selectedBoat?.boatId;
    if (boatId !== null) formData.append("BoatId", boatId!.toString());
    formData.append("SideImage", imagePreviews["FrontImage"].file!);
    Object.entries(imagePreviews).forEach(([name, file]) => {
      if (file !== null) formData.append(name, imagePreviews[name].file!);
    });
    photoMutations.mutate(formData);
    for (const [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`${key}:`, {
          size: value.size,
        });
      } else {
        console.log(`${key}:`);
      }
    }
  };

  const photoMutations = useMutation(
    (data: FormData) =>
      api.post(ApiRoutes.editBoatImages, data, {
        headers: { "Content-Type": "multipart/form-data" },
      }),
    {
      onSuccess: (res) => {
        console.log(res);
        toast.success("Photos uploaded successfully");
        navigate(routerPaths.boat);
      },
      onError(error) {
        handleErrorMessage(error, "Unable to upload photos");
      },
    }
  );

  const handleImageChange =
    (label: string) => (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
          setImagePreviews((prev) => ({
            ...prev,
            [label]: { file, preview: reader.result as string },
          }));
        };

        reader.readAsDataURL(file);
      }
    };

  useEffect(() => {
    if (selectedBoat === undefined) {
      navigate(routerPaths.boat);
    }
  }, [navigate, selectedBoat]);

  return (
    <div className="p-10 ">
      <div className="w-full">
        <Typography
          placeholder={undefined}
          className="text-center mb-6 font-medium text-2xl"
        >
          Edit photos of your boat
        </Typography>
        <div className="flex justify-center">
          <div className="md:w-3/5 md:mx-11 w-full  place-self-center">
            <ImageUpload
              label="Sea View"
              onChange={handleImageChange("SeaViewImage")}
              preview={imagePreviews["SeaViewImage"].preview}
              height="15rem"
            />
          </div>
        </div>
        <div className="justify-center md:flex pt-5">
          <ImageUpload
            label="Front View"
            onChange={handleImageChange("FrontImage")}
            preview={imagePreviews["FrontImage"].preview}
          />
          <ImageUpload
            label="Back View"
            onChange={handleImageChange("BackImage")}
            preview={imagePreviews["BackImage"].preview}
          />
          <ImageUpload
            label="Interior View"
            onChange={handleImageChange("InteriorImage")}
            preview={imagePreviews["InteriorImage"].preview}
          />
          <ImageUpload
            label="Exterior View"
            onChange={handleImageChange("ExteriorImage")}
            preview={imagePreviews["ExteriorImage"].preview}
          />
        </div>
        <NextBack
          isLoading={photoMutations.isLoading}
          next={() => onSubmit()}
          shouldGoNext={
            !Object.values(imagePreviews).some(
              ({ preview }) => preview === null
            )
          }
          back={() => {
            navigate(routerPaths.boat);
          }}
          shouldGoBack={true}
        />
      </div>
    </div>
  );
};

export default EditPhotos;
